import { HyperLink, Icons, Text } from '@doist/marketist'
import { AutocompleteSearchResult } from '@doist/marketist/dist/components/AutocompleteSearch/AutocompleteSearch'

import css from './SearchResult.module.css'

export type SearchResultProps = {
    searchResult: AutocompleteSearchResult
}

export function SearchResult({ searchResult, ...rest }: SearchResultProps) {
    return (
        <HyperLink
            className={css.searchResult}
            href={`/help/articles/${searchResult.id}`}
            {...rest}
        >
            <div className={css.icon}>
                <Icons.Article />
            </div>
            <div className={css.content}>
                <Text size="body-base">{searchResult.title}</Text>
                <Text size="body-sm">{searchResult.description}</Text>
            </div>
        </HyperLink>
    )
}
